<template>
  <div class="sidebar-content">
    <BMenu>
      <template #activator>
        <div class="sidebar-profile">
          <div
            class="user-name truncate-text"
          >
            {{ currentUser?.name }}
          </div>
          <BAvatar
            class="ml-100"
            :size="36"
            :image-url="currentUser?.avatarUrl"
            :name="currentUser?.name"
            :user-id="currentUser?.id"
          />
        </div>
      </template>
      <BCard
        class="sidebar-card"
        full
      >
        <div class="py-300">
          <BTooltip
            top
            :content="$t('general.signOut')"
          >
            <BCustomIcon
              class="logout-button"
              icon-class="b-logout"
              hover
              @click="confirmSignOut"
            />
          </BTooltip>
          <div class="mx-400 pr-300">
            <div class="fw-bold truncate-text">
              {{ currentUser?.clientName }}
            </div>
            <div class="user-name truncate-text">
              {{ currentUser?.name }}
            </div>
            <div class="user-email truncate-text">
              {{ currentUser?.email }}
            </div>
          </div>
        </div>
      </BCard>
    </BMenu>
  </div>
</template>

<script lang="ts" setup>
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCurrentUserProvider } from '@/composable/current-user';
import { useConfirm } from '@/composable/message-dialog';
import { KEY_OF_TOAST } from '@/injection-keys';
import router from '@/router';
import UserService from '@/services/user_service';

const { inject: injectCurrentUser } = useCurrentUserProvider();
const { currentUser } = injectCurrentUser();
const i18n = useI18n();
const { confirm } = useConfirm();
const toast = inject(KEY_OF_TOAST);
const userService = new UserService();

const signOut = () => {
  userService.signout().then(() => {
    router.push({ name: 'VaAppSignin' });
  }).catch(() => {
    toast.show({
      type: 'error',
      message: i18n.t('general.fail.to', {
        action: i18n.t('general.signOut'),
      }),
    });
  });
};

const confirmSignOut = async () => {
  const check = await confirm({
    title: i18n.t('general.signOut'),
    message: i18n.t('general.confirm.of', { action: i18n.t('general.signOut') }),
  });
  if (!check) { return; }
  signOut();
};
</script>

<style scoped lang="scss">
  .sidebar-card {
    width: 320px;
  }

  .logout-button {
    position: absolute;
    top: $basespace-200;
    right: $basespace-200;
  }

  .user-name {
    font-size: 12px;
  }

  .user-email {
    color: $textcolor-light;
    margin-top: 3px;
    font-size: 11px;
  }

  .sidebar-profile {
    display: flex;
    transition: $transition-base;
    margin-right: 8px;
    align-items: center;
    justify-content: center;
    padding-left: $basespace-100;
    padding-right: $basespace-400;
    height: $header-height;
    cursor: pointer;

    &:hover {
      background-color: $bgcolor-dark;
    }
  }

  .sidebar-content {
    display: flex;
    position: relative;
    align-items: center;
  }
</style>
